module.exports = __webpack_public_path__ + "img/qrcode-cattle-365.9d3bca97.png";